<fieldset>
    <div class="ib-gift-card__importTextContainer" ng-if="ibGiftCardsImportCtrl.flow == 'contribution'">
        <legend class="ib-gift-cards__title ib-gift-card__legendImport">{{'GIFT_CARD_AMOUNT_OF_YOUR_CONTRIBUTION'|translate}}</legend>
    </div>
    
    <div class="ib-layout__line-spacing ib-layout__line-spacing--large u-mb-mobile" id="divImportPrices">
        <div class="row">
            <!--Radio buttons-->
            <div [formGroup]="form">
                <div class="col-lg-9 col-md-9" id="divImportPricesRadios">
                    <div class="row">
                        <div class="col-md-3 col-sm-6 u-mb-mobile ib-gift-cards__col"
                             *ngFor="let groupFixedPrice of groupFixedPrices; let first = first">
                            <div class="ib-form-box-input ib-form-box-input--medium"
                                [ngClass]="{'ib-form-box-input--checked' : form.get('giftCardAmount').value?.amount === groupFixedPrice.amount}">
                                <div class="ib-radio">
                                    <input *ngIf="first" class="ib-radio__input"
                                           type="radio" 
                                           name="giftCardAmount"
                                           formControlName="giftCardAmount"
                                           [id]="groupFixedPrice.amount"
                                           [value]="groupFixedPrice"
                                           checked
                                    />
                                    <input *ngIf="!first" class="ib-radio__input"
                                           type="radio" 
                                           name="giftCardAmount"
                                           formControlName="giftCardAmount"
                                           [id]="groupFixedPrice.amount"
                                           [value]="groupFixedPrice"
                                    />
                                    <label class="ib-radio__label" [for]="groupFixedPrice.amount">
                                        <span
                                            class="ib-radio__text ib-radio__text--gift-card">{{groupFixedPrice.amount}} {{contributionService.contributionDataResponse.currency.symbol}}</span>
                                    </label>
                                </div>
                            </div>
                            <span *ngIf="groupFixedPrice.discount"
                                class="ib-alert ib-alert--warning ib-alert--bold ib-alert--icon u-mt-xxsmall icon-mejor_precio">
                                {{'IMPORT_PROMOTION_DISCOUNT_MESSAGE' | translate}} {{groupFixedPrice.discount!.amount}}
                            </span>
                        </div>
                    </div>
                </div>
                <!--input CustomPrice-->
                <div class="col-lg-3 col-md-3 u-mb-mobile u-mb-none-mobile" ng-if="groupCustomFixedPrice !== null ">
                    <div class="ib-input ib-input--custom-amount">
                        <label class="ib-input__label" for="customAmount"
                            [ngClass]="{'ib-input__label--focus' : customPriceSelected !== ''}">
                            {{'GIFT_CARD_CONFIGURATION_OTHER_IMPORT'|translate}}
                        </label>
                        <input class="ib-input__input"
                               type="text"
                               id="customAmount"
                               pattern="^([0-9])*$"
                               name="giftCardCustomAmount"
                               [attr.maxlength]="(groupCustomFixedPrice.maxAmount)?.toString()?.length"
                               minlength="1"
                               (input)="inputIsChanged($event)"
                        />
                    </div>
                     <span *ngIf="showCustomDiscount && form.get('giftCardAmount').errors === null"
                          class="ib-alert ib-alert--warning ib-alert--bold ib-alert--icon u-mt-xxsmall icon-mejor_precio"
                          [attr.aria-label]="contributionService.getInstantTranslate('IMPORT_PROMOTION_DISCOUNT_MESSAGE')">
                                {{'IMPORT_PROMOTION_DISCOUNT_MESSAGE' | translate}} {{customPriceSelectedDiscountCalculated}}
                    </span>
                    <span *ngIf="form.get('giftCardAmount').errors?.amountTooLow || form.get('giftCardAmount').errors?.amountTooHigh"
                          class="ib-alert ib-alert--warning  ib-alert--small ib-alert--bold u-mt-xxsmall">
                                {{ customPriceErrorTranslate }}
                    </span>
                    <span *ngIf="form.get('giftCardAmount').errors?.notNumeric"
                          class="ib-alert ib-alert--warning  ib-alert--small ib-alert--bold u-mt-xxsmall">
                                {{'GENERAL_INPUT_PATTERN_ERROR'|translate}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</fieldset>